<template>
  <PortalCard
      :content="content"
      :characters="characters"
      @clickCard="handleClick"
    />
</template>

<script lang="ts">
import { Content, Sequence } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import PortalCard from '../Portal/PortalCard.vue'

@Component({
  components: {
    PortalCard
  }
})
export default class PortalEnd extends Vue {
  @Prop({ type: Object }) content!: Content & { portalSequence: Sequence; name: string };
  @Prop({ type: Array }) characters!: Array<{
    name: string;
    avatar: string;
    direction?: 'right' | 'left';
  }>;

  handleClick() {
    if (!this.content.portalSequence) return;
    this.$store.commit('common/setPortal', {
      ...this.content.portalSequence,
      scrollTop: (this.$parent?.$refs?.scroller as HTMLElement).scrollTop
    });
  }
}
</script>
